import Flickity from 'flickity';

import 'flickity-fade';
import 'flickity-imagesloaded';
import 'flickity/dist/flickity.css';

(() => {
    const recentlyViewedCarouselContainer = document.querySelector(
        '[data-recently-viewed-carousel]',
    );

    if (recentlyViewedCarouselContainer) {

        const recentlyViewedCarousel = new Flickity(recentlyViewedCarouselContainer, {
            // eslint-disable-line no-new
            cellSelector: '[data-recently-viewed-carousel-item]',
            imagesLoaded: true,
            pageDots: false,
            prevNextButtons: true,
            wrapAround: false,
            contain: false,
            adaptiveHeight: true,
            initialIndex: 1
        });
    }

    const recentlyViewedImagesCarousel = document.querySelectorAll(
        '[data-recently-viewed-images-carousel]',
    );

    if (recentlyViewedImagesCarousel.length > 0) {

        recentlyViewedImagesCarousel.forEach(function(carousel) {
            const imagesCarousel = new Flickity(carousel, {
                // eslint-disable-line no-new
                cellSelector: '[data-recently-viewed-images-carousel-item]',
                imagesLoaded: true,
                pageDots: false,
                prevNextButtons: true,
                wrapAround: true,
                contain: false,
                adaptiveHeight: false
            });
        });
    }
})();
